import { render, staticRenderFns } from "./InviteMemberItem.vue?vue&type=template&id=0445f3c4&scoped=true"
import script from "./InviteMemberItem.vue?vue&type=script&lang=js"
export * from "./InviteMemberItem.vue?vue&type=script&lang=js"
import style0 from "./InviteMemberItem.vue?vue&type=style&index=0&id=0445f3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445f3c4",
  null
  
)

export default component.exports